function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M0 0h20l10 9.75V40H0z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#E3E7F4",
  fillRule: "nonzero",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#b)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.333 31.996a3.334 3.334 0 0 0 3.332-3.333v-3.332h-3.332a3.334 3.334 0 0 0 0 6.665z",
  fill: "#0ACF83"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 21.998a3.334 3.334 0 0 1 3.333-3.333h3.332v6.666h-3.332A3.334 3.334 0 0 1 8 21.998z",
  fill: "#A259FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 15.333A3.334 3.334 0 0 1 11.333 12h3.332v6.665h-3.332A3.334 3.334 0 0 1 8 15.333z",
  fill: "#F24E1E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.665 12h3.333a3.334 3.334 0 0 1 0 6.665h-3.333V12z",
  fill: "#FF7262"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.33 21.998a3.334 3.334 0 0 1-6.665 0 3.334 3.334 0 0 1 6.666 0z",
  fill: "#1ABCFE"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#CFD4E5",
  fillRule: "nonzero",
  mask: "url(#b)",
  d: "M20 0h10v10H20z"
}));

var SvgFigma = function SvgFigma(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 40,
    viewBox: "0 0 30 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFigma, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/figma.98bf025d.svg";
export { ForwardRef as ReactComponent };